var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [
      _vm._v("Препарат: "),
      _c("strong", [_vm._v(_vm._s(_vm.drug.title))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("Накладная "),
      _c("strong", [_vm._v(_vm._s(_vm.invoice.id))]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-xs btn-info newWindowBtn",
          on: {
            click: function ($event) {
              return _vm.showInvoice(_vm.invoice.id)
            },
          },
        },
        [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pt-2" }, [
      _c("p", [
        _vm._v("В накладной количество: "),
        _c("strong", [_vm._v(_vm._s(_vm.taskData.invoice_qty))]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("На складе отправителя: "),
        _c("strong", [_vm._v(_vm._s(_vm.taskData.store_remain))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }